import { memo, type FC, type ReactNode } from "react";
import type { SelectProps } from "antd";
import StyledDropdown from "src/components/reusable/StyledDropdown";
import type { SegmentCondition } from "../CreateSegment.Constants";

export interface ConditionFieldsProps<T extends SegmentCondition> {
  condition: T;
  onChange: (_condition: SegmentCondition) => void;
}

export const SegmentSelect: FC<SelectProps> = memo(({ className = "", popupClassName = "", ...props }) => (
  <StyledDropdown
    {...props}
    className={`campaign-flow__select segment-builder__select ${className}`}
    popupClassName={`campaign-flow__popup segment-builder__popup ${popupClassName}`}
  />
));

SegmentSelect.displayName = "SegmentSelect";

interface ConditionFieldsRowProps {
  label: string;
  children: ReactNode;
}

export const ConditionFieldsRow: FC<ConditionFieldsRowProps> = memo(({ label, children }) => (
  <div className="segment-builder__fields">
    <span className="segment-builder__fields-label">{label}</span>
    {children}
  </div>
));

ConditionFieldsRow.displayName = "ConditionFieldsRow";
